<template>
    <div>
        <h3 style="text-align: left">Add Guest Tickets</h3>
        <hr>
        <vue-form :state="formstate">
            <validate auto-label class="form-group required-field"
                      :class="fieldClassName(formstate.guest)">
                <label>Welcome Reception Guest Tickets: ${{state.meetingData.guest}}</label>
                <select @change="setGuestTotal" class="form-control" name="department" required
                        v-model.lazy="state.registrantData.guests">
                    <option value="0" selected>0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
                <field-messages name="howDidYouHear" show="$touched || $dirty || $submitted"
                                class="form-control-feedback">
                    <div>Success!</div>
                    <div slot="required">This is a required field</div>
                </field-messages>
            </validate>
            <validate auto-label class="form-group"
                      :class="fieldClassName(formstate.guestNames)">
                <label>Guest Names</label>
                <input type="text" name="guestNames" class="form-control"
                       v-model.lazy="state.registrantData.guestNames">
                <field-messages name="guestNames" show="$touched || $submitted"
                                class="form-control-feedback">
                    <div>Success!</div>
                </field-messages>
            </validate>
        </vue-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "GuestTickets",
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
        },
        methods:{
            setGuestTotal() {
                if (this.state.registrantData.guests > 0) {
                    this.state.registrantData.guestTotal = parseInt(this.state.registrantData.guests * this.state.meetingData.guest).toFixed(2);
                } else {
                    this.state.registrantData.guestTotal = 0;
                }
                this.$store.commit('updateTotal');
            },
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
        }
    }
</script>

<style scoped>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>